import { render, staticRenderFns } from "./InformacionSinActividades.vue?vue&type=template&id=7647cbe5&scoped=true"
import script from "./InformacionSinActividades.vue?vue&type=script&lang=js"
export * from "./InformacionSinActividades.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7647cbe5",
  null
  
)

export default component.exports